import React from 'react';
import EmptyCell from './EmptyCell';

export default value => {
    if (value === null) {
        return <EmptyCell />;
    }
    const formattedValue = toCurrencyFormat(value);
    return <div className="cell numeric">{formattedValue}</div>;
};

const toCurrencyFormat = value => {
    value = Number.parseFloat(value);
    if (Number.isNaN(value)) {
        return '$0.00';
    }
    let negativeSymbol = value < 0 ? '-' : '';
    value = Math.abs(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return `${negativeSymbol}$${value}`;
};
